<template>
  <div>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		<el-form-item label=''><el-input clearable  @change="callbackIndex(1)" @clear='callbackIndex(1)' v-model='form.title' placeholder='标题'></el-input></el-form-item>
		<!-- <el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.orders' placeholder='排序'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.urls' placeholder='链接'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.statusGroup' placeholder='分组ID'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.statusType' placeholder='类型ID'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.parentId' placeholder='父级ID'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.parentName' placeholder='父级名称'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.parentIds' placeholder='父级IDS'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.isShow' placeholder='是否上级'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.status' placeholder='状态'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.tag' placeholder='标签'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.brief' placeholder='摘要'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.imgurl' placeholder='图片'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.createId' placeholder='创建ID'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.createTime' placeholder='创建时间'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.extFlag' placeholder='扩展'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.extMore' placeholder='扩展'></el-input></el-form-item>
		<el-form-item label=''><el-input clearable  @clear='callbackIndex(1)' v-model='form.ext' placeholder='扩展字段'></el-input></el-form-item> -->
		<el-form-item  label="">
		    <el-date-picker prefix-icon="none"
		         v-model="form.dateRange"
		         type="datetimerange" :editable="false"
				 value-format='yyyy-MM-dd HH:mm:ss'
				  start-placeholder="开始时间"
				       end-placeholder="结束时间"
		         range-separator=""
				   @change="callbackIndex(1)">
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		 <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		:height="$store.state.height-328"
		ref="multipleTable"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty"><el-empty description="暂时没有数据"></el-empty> </template>
		      <el-table-column type="selection"></el-table-column>
		   <com-page-index></com-page-index>
		 <el-table-column prop='title' label='标题' ></el-table-column>
		 <!-- <el-table-column prop='subTitle' label='副标题' ></el-table-column> -->
		 <com-page-orders></com-page-orders>
		 <!-- <el-table-column prop='urls' label='链接' ></el-table-column>
		 <el-table-column prop='statusGroup' label='分组ID' ></el-table-column>
		 <el-table-column prop='statusType' label='类型ID' ></el-table-column>
		 <el-table-column prop='parentName' label='父级名称' ></el-table-column> -->
		 <com-page-isshow></com-page-isshow>
		<!-- <el-table-column prop='statusText' label='状态' ></el-table-column>
		 <el-table-column prop='tag' label='标签' ></el-table-column>
		 <el-table-column prop='brief' label='摘要' ></el-table-column>
		 -->
		 <el-table-column prop='createTime' label='创建时间' ></el-table-column>
	
		 <!-- 操作按钮 -->
		<com-page-operate :columnList="columnList"  :pageData="pageData" @callbackOperate="callbackOperate"></com-page-operate>
      </el-table>
	    <!-- 分页页面 -->
	  <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </div>
</template>
<script>
import edit from "@/components/edit/com-edit-classify"; 
export default {
  components: {edit },
  data() {
    return {
	columnList:[],//权限列
		pageData:[],//页面数据
		id:'',//表单主键id
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,//时间
		id:'',//ID
		orders:'',//排序
		urls:'',//链接
		statusGroup:'',//分组ID
		statusType:'',//类型ID
		parentId:'',//父级ID
		parentName:'',//父级名称
		parentIds:'',//父级IDS
		isShow:'',//是否上级
		status:'',//状态
		tag:'',//标签
		brief:'',//摘要
		imgurl:'',//图片
		createId:'',//创建ID
		createTime:'',//创建时间
		extFlag:'',//扩展
		extMore:'',//扩展
		ext:'',//扩展字段
		},
    };
  },
   watch: {
      $route(to,from){ //路由监听
	   this.form.dateRange=this.$dateRangeCurrent;
		 this.form.id='';//ID
		 this.form.orders='';//排序
		 this.form.urls='';//链接
		 this.form.statusGroup='';//分组ID
		 this.form.statusType='';//类型ID
		 this.form.parentId='';//父级ID
		 this.form.parentName='';//父级名称
		 this.form.parentIds='';//父级IDS
		 this.form.isShow='';//是否上级
		 this.form.status=this.$route.query.status||'';//状态
		 this.form.tag='';//标签
		 this.form.brief='';//摘要
		 this.form.imgurl='';//图片
		 this.form.createId='';//创建ID
		 this.form.createTime='';//创建时间
		 this.form.extFlag='';//扩展
		 this.form.extMore='';//扩展
		 this.form.ext='';//扩展字段
		 this.callbackIndex(1)
        }
     },
  methods: {
   callbackImport(){//导入回调
		   this.callbackIndex(1)
	  },
	   selectChange(selection,row){//选择
	  this.$store.commit("saveSelect", selection);
	  },
	  sortChange(column){//排序回调
		var list= this.$store.state.list;
		list.pageOrder=column.order == 'descending'?'desc':'asc';
		list.pageSort=column.prop;
		this.$store.commit("saveList", list);
		 this.callbackIndex(1)
	},
	  callbackOperate(e){//操作按钮事件
		  if(e.operate=='添加')
			  this.id="";
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情')
			  this.id=(e.data.id||'').toString();
		if(e.operate=='删除'){
			var id=this.$store.state.select.map(item=>item.id).join(',');
			 localStorage.setItem('SELECTIDS',id)
				this.$axios.post(`/api/Classify/PostClassifyDeleteWhere` ,'').then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex(1);
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/Classify/GetClassifyPage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    }
  },
  mounted() {//页面加载事件
   this.form.status=this.$route.query.status||'';
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
  }
  
};
</script>
<style>
</style>

